import React from "react";
import { motion } from "../components/StaticMotion";
import { HoverCard, HoverIcon } from "../components/HoverMotion";

const cardVariants = {
  hidden: { opacity: 0, y: 25, scale: 0.95 },
  visible: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.6, ease: "easeOut" } },
};

export const SectionWhyChooseUs = () => {
  const benefits = [
    {
      id: 1,
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
        </svg>
      ),
      title: "Modern Tools",
      description:
        "Using up-to-date and well-integrated technology for various operations.",
    },
    {
      id: 2,
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M3 13h8v2H3zm0 4h8v2H3zm0-8h8v2H3zm13 0h3v2h-3zm0 4h3v2h-3zm0 4h3v2h-3z" />
        </svg>
      ),
      title: "Scalable System",
      description:
        "Capable of handling large operations efficiently and reliably.",
    },
    {
      id: 3,
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M16.6915026,12.4744748 L3.50612381,13.2599618 C3.19218622,13.2599618 3.03521743,13.4170592 3.03521743,13.5741566 L1.15159189,20.0151496 C0.8376543,20.8006365 0.99,21.89 1.77946707,22.52 C2.41,22.99 3.50612381,23.1 4.13399899,22.8429026 L21.714504,14.0454487 C22.6563168,13.5741566 23.1272231,12.6315722 22.9702544,11.6889879 L4.13399899,1.16858361 C3.34915502,0.9114862 2.40734225,1.01396248 1.77946707,1.4852546 C0.994623095,2.10604706 0.837654326,3.0486314 1.15159189,3.99121575 L3.03521743,10.4322088 C3.03521743,10.5893061 3.34915502,10.7464035 3.50612381,10.7464035 L16.6915026,11.5318905 C16.6915026,11.5318905 17.1624089,11.5318905 17.1624089,12.0031827 C17.1624089,12.4744748 16.6915026,12.4744748 16.6915026,12.4744748 Z" />
        </svg>
      ),
      title: "Fast Delivery",
      description:
        "Quick and efficient execution ensuring smooth, reliable operations.",
    },
  ];

  return (
    <section id="why-choose-us" className="w-full py-16 lg:py-24 px-4 bg-white overflow-hidden">
      <motion.div
        className="w-full max-w-6xl mx-auto"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.6 }}
      >
        <div className="text-center mb-10">
          <motion.h2
            className="text-3xl md:text-4xl font-black text-gray-900 uppercase tracking-tight mb-3"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            Why Choose Us
          </motion.h2>
          <motion.p
            className="text-gray-600 max-w-3xl mx-auto"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.15 }}
          >
            We combine technical depth with operational experience to deliver event technology that is reliable, scalable, and built around the real demands of organizers and participants.
          </motion.p>
        </div>

        <motion.div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4"
          variants={{ visible: { transition: { staggerChildren: 0.12, delayChildren: 0.2 } } }}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {benefits.map((benefit, index) => (
            <motion.div
              key={benefit.id}
              variants={cardVariants}
            >
              <HoverCard className={`p-4 h-full flex items-start gap-4 rounded-card border border-slate-200 ${index === 1 ? "bg-slate-900" : "bg-white"}`}>
                <HoverIcon className={`w-10 h-10 flex items-center justify-center flex-shrink-0 rounded-icon border ${index === 1 ? "bg-white/10 border-white/20 text-white" : "bg-slate-100 border-slate-200 text-slate-700"}`}>
                  {benefit.icon}
                </HoverIcon>
                <div className="flex-1">
                  <h3 className={`text-lg font-bold mb-1 ${index === 1 ? "text-white" : "text-slate-900"}`}>
                    {benefit.title}
                  </h3>
                  <p className={`text-sm leading-relaxed ${index === 1 ? "text-slate-300" : "text-slate-600"}`}>
                    {benefit.description}
                  </p>
                </div>
              </HoverCard>
            </motion.div>
          ))}
        </motion.div>
      </motion.div>
    </section>
  );
};
